import React, { useEffect, useState } from 'react'
import HomeLayout from '../../../layouts/Home'
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from '@mui/lab';
import config from "../../../utils/config";
import { Link, useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material';
import Table from '../../../components/table/Table';
import Menu from '../../../utils/data.dropdown';
import { closeModal, deleteDesignation, getDesignations, getDesignationData, openModal, setPagination } from '../../../features/hospitals/designation';
import { useDispatch, useSelector } from 'react-redux';
import TablePreloader from '../../../components/Loader/TablePreloader';
import CancelModal from '../../../components/Modals/Cancel';
import { getIds } from '../../../utils/helper';
import { IError } from '../../../utils/icons.utils';


const { routes } = config;

export default function Designation () {
  const {designations, pagination, loading, modal } = useSelector(getDesignationData),
  [isLoading, setIsLoading] = useState(true),
  [deleteDesignationData, setDeleteDesignationData] = useState({name: '', id: ''}),
  navigate = useNavigate(),
  dispatch = useDispatch();

   useEffect( () => {
    (async () => await dispatch(getDesignations({hospitalId: getIds().hospital})))()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page])

  useEffect( ()=> {
    setIsLoading(false)
  }, [])

    let data = designations?.map( designation => ({
      "Name": designation?.name,
      _data: designation
    }) )

  const menu = new Menu({});
  const dropdownMenu = [
    menu.edit({
      navigate,
      route: routes.hospitals.designations.designation,
      name: 'Edit'
    }),
    menu.delete({action: (value) => {
      setDeleteDesignationData({id: value?.id, name: value?.name})
      dispatch(openModal('delete'))
}
}),
  ]

  const handleDelete = async () => {
    const res = await dispatch(deleteDesignation(deleteDesignationData.id)).unwrap()
    res?.success === true && dispatch(getDesignations({hospitalId: getIds().hospital}))
  }

  return (
    <HomeLayout {...{ title: 'Configuration' }}>
      <Box className='flex justify-end mt-4 mb-10'>
      <LoadingButton
      LinkComponent={Link}
            className="w-[233px] h-[56px] bg-[var(--c-primary-0)] mr-8 text-[600] text-[18px] rounded-xl shadow-none normal-case"
            size="small"
            type="submit"
            variant="contained"
            fullWidth
            startIcon={<AddIcon />}
            to={routes.hospitals.designations.new}
          >
            Add Designation
          </LoadingButton>
      </Box>
      <Box className="pt-8 px-8 pb-2 bg-[var(--c-bg-color)] rounded-lg w-100%" sx={{ p: 0 }}>
      {isLoading ? (
						<TablePreloader />
					) : data?.length ? (
						<Table
							{...{
								dropdownMenu,
								// checkData: rows,
								// checkbox: rows,
								data,
              pagination,
              setPagination: d => dispatch(setPagination(d())),
								isLoading: loading,
							}}
						/>
					) : (
            <Box
            className="pt-8 pb-28 mt-8 bg-[var(--c-bg-color)] w-100% rounded-lg flex flex-col justify-center"
            sx={{ p: 0 }}
          >
            <img
            className="m-auto w-[350px] mt-8"
            src={IError}
            alt={"error"}
            loading="lazy"
          />
          <Typography className="flex justify-center text-[400] text-xl text-[#040316] mx-2 text-center">
          No Designation in the system at the moment
          </Typography>
          </Box>
					)}
        </Box>

        <CancelModal
         {...{
           open: modal.delete,
           loading: modal.loading,
            title: 'Delete Designation',
            subtitle: `Are you sure you want to delete ${deleteDesignationData.name}?`,
            btnTexts: ['Cancel', 'Delete'],
            handleSuccess: handleDelete,
            handleClose: _=> dispatch(closeModal('delete'))
         }}
         />
    </HomeLayout>
  )
}
